import React, { Component } from 'react'
import { Upload, Icon, Modal, message } from 'antd'
import { connect } from 'react-redux'
import { fileUpload } from '../../../action/process/fileUpload'

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

class FileUpload extends Component {
  constructor(props) {
    super(props)

    const fileList = this.props.value || []
    this.state = {
      previewVisible: false,
      previewImage: '',
      max: 2,
      fileList
    }
  }
  handleCancel = () => this.setState({ previewVisible: false })
  // 点击文件链接或预览图标时的回调
  handlePreview = (file) => {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true,
    })
  }
  // 移除
  handleRemove = ({ uid }) => {
    let { fileList } = this.state
    fileList = fileList.filter(file => file.uid !== uid)
    this.setState({ fileList }, () => {
      const onChange = this.props.onChange
      if (onChange) {
        onChange(fileList.map(item => item.uid))
      }
    })
    return true
  }
  // 上传中、完成、失败都会调用这个函数。 event上传中的服务端响应内容
  handleChange = ({ file }) => {
    const { fileUpload } = this.props
    const { fileList } = this.state
    const { name, size, type, uid } = file
    let index = name.lastIndexOf('.')
    getBase64(file, (imageUrl) => {
      imageUrl = imageUrl.slice(imageUrl.indexOf(',') + 1)
      const params = {
        file: imageUrl,
        fileType: name.slice(index + 1),
        fileName: name.slice(0, index)
      }
      this.props.fileUpload(params).then(res => {
        const { retCode, retData, retMsg } = res
        if (retData && retData.id) {
          fileList.push({
            uid: retData.id,
            name,
            status: 'done',
            url: retData.url
          })
          this.setState({ fileList })
          // successHandle(fileList)

          // 自定义表单组件接口onChange
          const onChange = this.props.onChange
          if (onChange) {
            onChange(fileList.map(item => item.uid))
          }
        }
      })
    })
  }
  beforeUpload = (file) => {
    // const isLt3M = file.size / 1024 / 1024 < 3
    // if (!isLt3M) {
    //   message.error('文件不能超过3MB!')
    // }
    // return isLt3M
    return true;
  }
  render() {
    const { previewVisible, previewImage, fileList } = this.state;
    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">Upload</div>
      </div>
    )
    return (
      <div className="clearfix">
        <Upload
          multiple
          action="/index/upload"
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          customRequest={this.handleChange}
          beforeUpload={this.beforeUpload}
          onRemove={this.handleRemove}
        >
          {fileList.length >= 5 ? null : uploadButton}
        </Upload>
        <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel} width={970}>
          <div style={{ textAlign: 'center', padding: '15px' }}>
            <img alt="example" style={{ maxWidth: '100%' }} src={previewImage} />
          </div>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const {
		page: {
		}
	} = state
  return {
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    fileUpload: (params) => dispatch(fileUpload(params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FileUpload)


// WEBPACK FOOTER //
// ./src/components/process/formWrapper/fileUpload.js